(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["widget-product-size"] && !Shopify.designMode) return;
  try {
    
  customElements.define('product-size', class extends HTMLElement {
    constructor() {
      super();

      this.tabs = this.querySelectorAll('.size__button');
      this.panels = this.querySelectorAll('.tab-panel');
      this.initAction();
    } 

    initAction() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          this.tabs.forEach((e) => {
            e.classList.remove('active');
          });
          tab.classList.add('active');
          this.panels.forEach((e) => {
            e.classList.remove('active');
          });
          this.panels[index].classList.add('active');
        }); 
      })
    }
  })

  } catch(e) { console.error(e); }
})();
})();
